import React, {Component} from 'react'
import {Route, Switch} from 'react-router-dom'
import SecuredApp from './SecuredApp'

export default class AsyncApp extends Component {

    render() {
        return (
            <Switch>
                <Route path="/" component={SecuredApp} />
            </Switch>
        )
    }

}
